export const BUILDER_STRATEGY_BLOCKS = {
  THEN: "then",
  ELSE: "else",
};

export const BUILDER_CONDITION_SIDES = {
  FIRST: "first",
  SECOND: "second",
};

export const BUILDER_ACTION_TYPES = {
  ALLOCATION: "allocation",
  TRADE: "trade",
  NOTIFICATION: "notification",
};

export const BUILDER_FIELDS = {
  AMOUNT: "amount",
  ASSET: "asset",
  ASSET_GROUPS: "asset_groups",
  NOTIFICATION: "notification",
  NAME: "name",
  TICKER: "ticker",
  VALUE: "value",
  LENGTH: "length",
  SIDE: "side",
  WEIGHT: "weight",
  ARGS: "args",
};

export const BUILDER_WEIGHT = {
  PERCENTAGE: "percentage",
  SHARES: "shares",
};

export const BUILDER_INDICATOR = {
  CONSTANT: "constant",
};
